<template>
  <div class="Slope" :style="componentStyle">
    <div
      class="Slope__bg"
      :style="`background-color: ${bgColor}; color: ${textColor};`"
    >
      <template v-if="borderLeft">
        <div class="Slope--border Slope--border-left Slope--border-long"></div>
        <div class="Slope--border Slope--border-left Slope--border-short"></div>
      </template>

      <template v-if="borderRight">
        <div class="Slope--border Slope--border-right Slope--border-long"></div>
        <div
          class="Slope--border Slope--border-right Slope--border-short Slope--border-lower"
        ></div>
      </template>
    </div>
    <v-container
      class="Slope__content"
      :style="`${!padless && 'padding-bottom: 125px;'}`"
    >
      <slot />
    </v-container>
  </div>
</template>

<script>
export default {
  name: "Slope",

  props: {
    padless: {
      default: false,
    },
    componentStyle: {
      type: String,
    },
    bgColor: {
      default: "#f6f9fc",
    },
    textColor: {
      default: "#000",
    },
    borderLeft: {
      default: true,
    },
    borderRight: {
      default: false,
    },
  },
};
</script>

<style>
.Slope {
  position: relative;
  min-height: 300px;
  overflow: hidden;
}

.Slope__bg {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transform: skewY(-8deg);
  transform-origin: bottom right;
  margin-top: 40px;
}

.Slope__content {
  position: relative;
  /* padding-top: 18vw;
  padding-bottom: 8vw; */
  padding-top: 125px; /* 0 100px;*/
}

.Slope--border {
  height: 40px;
  opacity: 0.8;
}

.Slope--border-left {
  float: left;
  margin-top: -40px;
}

.Slope--border-long {
  background: #80e9ff;
  width: 30vw;
}

.Slope--border-short {
  margin-top: -65px;
  margin-left: 10vw;
  width: 15vw;
  background: #7a73ff;
}

.Slope--border-right {
  float: right;
  margin-top: -40px;
}

.Slope--border-lower {
  margin-top: -15px;
  margin-right: 10vw;
}
</style>
